import { cva, type VariantProps } from "class-variance-authority";
import { type JSX, splitProps } from "solid-js";

import { cn } from "../../lib/cn";

export const badgeVariants = cva(
  "inline-flex items-center rounded-[2px] border font-mono text-[0.8rem] leading-none whitespace-nowrap",
  {
    variants: {
      variant: {
        tag: "border-primary bg-primary px-2 py-1.5 text-card",
        seal: "border-2 border-current px-2 py-1 font-semibold tracking-widest uppercase -rotate-2",
      },
    },
    defaultVariants: {
      variant: "tag",
    },
  },
);

type BadgeProps = JSX.HTMLAttributes<HTMLSpanElement> & VariantProps<typeof badgeVariants>;

export function Badge(props: BadgeProps) {
  const [local, rest] = splitProps(props, ["class", "variant"]);
  return <span class={cn(badgeVariants({ variant: local.variant }), local.class)} {...rest} />;
}
